export let counterUp = () => {


  let counterCount = () => {

    function numberWithCommas(n) {
      var parts=n.toString().split(".");
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let i = 1;
    
    $('.impact-counter-numbers').each(function() {

      let counter = { var: 0 };
      // let theseNumbers = document.getElementById("tal-"+i);
      let theseNumbers = document.getElementById("impact-numbers-"+i);
      let endingCounterVar = $(theseNumbers).attr('data-count');

        
      gsap.to(counter, {
        duration:4,
        delay:0.5,
        var: endingCounterVar, 
        onUpdate: function () {
            let nwc = numberWithCommas(counter.var);
            theseNumbers.innerHTML = nwc;
        },
        ease:Circ.easeOut
      });
      i++
    });
  }

  ScrollTrigger.create({
    trigger: "#impact-tracker-trigger",
    start: "top bottom-=40",
    once:true,
    
    onEnter: function() {
      // alert('ok');
      counterCount();
    }
  });
}
